import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { DialogService } from '../../../core/services/dialog.service';
import { NewCreditCardDialogComponent } from '../../../shared/components/new-credit-card-dialog/new-credit-card-dialog.component';
import { NewCreditCardDialogResult } from '../../../shared/models/new-credit-card-dialog-step.enum';

@Component({
standalone: false,
  selector: 'app-new-credit-card-dialog-entry',
  styles: [''],
  template: '',
})
export class NewCreditCardDialogEntryComponent implements OnInit {
  constructor(private route: ActivatedRoute, private router: Router, private dialog: DialogService) {}

  public ngOnInit(): void {
    const paramMap = this.route.snapshot.queryParamMap;
    const status = paramMap.get('status');
    const returnPath = paramMap.get('returnPath') ?? '/creditCards';
    const redirectCode = paramMap.get('redirectCode');
    const liabilitiesPaymentType = paramMap.get('liabilitiesPaymentType');
    const mode = paramMap.get('mode');

    const step = !status ? 'start' : status === 'OK' ? 'success' : 'failure';

    this.dialog
      .open(NewCreditCardDialogComponent, {
        data: {
          step: step,
          returnUrl: returnPath,
        },
      })
      .afterClosed()
      .pipe(
        switchMap((result: NewCreditCardDialogResult) => {
          if (result === 'continue') {
            return this.router.navigate(['/creditCards/add'], { queryParams: { returnPath, redirectCode, liabilitiesPaymentType } });
          } else if (result === 'cancel') {
            return this.router.navigate(['../'], { relativeTo: this.route });
          } else if (result === 'close') {
            return this.router.navigate([returnPath], { queryParams: { mode } });
          }
        }),
      )
      .subscribe();
  }
}
